import { create } from 'zustand';

const useDataStore = create((set, get) => ({
    cache: {}, // key → { rows: [], allLoaded: bool, ts: number }

    getRows: (key) => get().cache[key]?.rows ?? [],
    isCached: (key) => Boolean(get().cache[key]),
    isAllLoaded: (key) => get().cache[key]?.allLoaded ?? false,

    setRows: (key, rows, allLoaded = false) => set((state) => ({
        cache: {
            ...state.cache,
            [key]: { rows, allLoaded, ts: Date.now() },
        },
    })),

    appendRows: (key, newRows) => set((state) => {
        const existing = state.cache[key]?.rows ?? [];
        return {
            cache: {
                ...state.cache,
                [key]: {
                    rows: [...existing, ...newRows],
                    allLoaded: state.cache[key]?.allLoaded ?? false,
                    ts: Date.now(),
                },
            },
        };
    }),

    markAllLoaded: (key, rows) => set((state) => ({
        cache: {
            ...state.cache,
            [key]: { rows, allLoaded: true, ts: Date.now() },
        },
    })),

    invalidate: (key) => set((state) => {
        const next = { ...state.cache };
        delete next[key];
        return { cache: next };
    }),

    invalidateAll: () => set({ cache: {} }),
}));

export default useDataStore;
